import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	button: {
		alignItems: 'center',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
	},
	popper: {
		zIndex: theme.zIndex.raised,
		minWidth: '100%',
	},
	listBox: {
		maxHeight: theme.size.small,
		overflowY: 'auto',
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.tiny,
		marginTop: theme.spacing.xxsmall,
		marginBottom: theme.spacing.xxsmall,
		padding: `${theme.spacing.xxsmall} 0`,
		backgroundColor: theme.dropdown.background.color.default,
		border: `1px solid ${theme.dropdown.border.color.default}`,
		borderRadius: theme.spacing.tiny,
		boxShadow: theme.elevation.top.lifted,
		zIndex: theme.zIndex.lifted,
	},
	listItem: {
		listStyle: 'none',
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.xsmall,
		cursor: 'pointer',
		minHeight: theme.spacing.large,
		padding: `${theme.spacing.tiny} ${theme.spacing.small}`,
		font: theme.typography.bodyMd,
		color: theme.dropdown.listItem.color.default,

		input: {
			zIndex: -1,
		},

		['&:hover']: {
			backgroundColor: theme.dropdown.listItem.background.color.hover,
		},
	},
	optionLabel: {},
	defaultList: {
		gap: theme.spacing.tiny,
	},
	selectedOption: {
		display: 'flex',
	},
	checkmark: {
		color: theme.checkbox.selected.background.color.default,
		paddingRight: theme.spacing.xsmall,
	},
	wrapperDiv: { position: 'relative' },
}));
